"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobViewStyled = void 0;
exports.JobViewStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;

  > h2 {
    font-weight: 600;
    font-size: 1.5em;
  }
}
`;
//# sourceMappingURL=JobView.styled.js.map